module.exports = __webpack_public_path__ + "static/img/半个地图.87b61d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/pc/aboutMe/半个地图.png
// module id = zGQt
// module chunks = 0 1 2 9